<template>
<!--  <div class="text-center">-->
    <v-dialog scrollable v-model="visible" max-width="700px" @click:outside="onClose">
      <v-card class="pa-5 branch-modal-border" style="max-height: 400px">
        <v-btn icon style="position: absolute; top: 5px; right: 5px;" @click="onClose">
          <v-icon small color="#2e8037">mdi-close</v-icon>
        </v-btn>
        <div class="sub-header1 px-3 mb-2 text-tcdc-green">miniTCDC</div>

<!--        <v-row class="d-flex flex-nowrap pb-5" style="overflow: auto;">-->

<!--          <v-slide-group>-->
<!--            <v-slide-item v-for="(zones, index) of items" :key="index.toString()">-->
<!--              <v-col style="min-width: 205px; max-width: 205px;" class="text-wrap wrap">-->
<!--                <span class="text-tcdc-green">{{ zones.zone }}</span>-->
<!--                <template v-for="(item, index) of zones.list">-->
<!--                  <div :key="index.toString()">-->
<!--                    <div class="dot-symbol mr-2" :style="{background: miniByBranch.find(x => x.branch_name_th === item.name).mini_type.marker_color ? miniByBranch.find(x => x.branch_name_th === item.name).mini_type.marker_color : 'transparent'}"></div>-->
<!--                    <span-->
<!--                        class="text-branch-modal-highlight cursor-pointer"-->
<!--                        style="font-size: 16px; font-family: Sarabun;"-->
<!--                        @click="selectItem(item.name)"-->
<!--                    >{{ item.name }}</span>-->
<!--                  </div>-->
<!--                </template>-->
<!--              </v-col>-->
<!--            </v-slide-item>-->
<!--          </v-slide-group>-->
              <div class="pb-5 px-3" style="display: flex; overflow: auto; position: relative; z-index: 99;">
                <div
                    class="mr-2 text-wrap wrap"
                    v-for="(zones, index) of items" :key="index.toString()"
                    style="min-width: 205px; max-width: 205px; display: inline-block;"
                >
                  <span class="text-tcdc-green">{{ zones.zone }}</span>
                  <template v-for="(item, index) of zones.list">
                    <div :key="index.toString()">
                      <div class="dot-symbol mr-2" :style="{background: miniByBranch.find(x => x.branch_name_th === item.name).mini_type.marker_color ? miniByBranch.find(x => x.branch_name_th === item.name).mini_type.marker_color : 'transparent'}"></div>
                      <span
                          class="text-branch-modal-highlight cursor-pointer"
                          style="font-size: 16px; font-family: Sarabun;"
                          @click="selectItem(item.name)"
                      >{{ item.name }}</span>
                    </div>
                  </template>
                </div>
              </div>



<!--        </v-row>-->
      </v-card>
    </v-dialog>
<!--  </div>-->
</template>

<script>
import { mapState } from "vuex"

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  computed:{
    ...mapState({
      form : state=>{
        if (state.About.form) {
          return state.About.form;
        }
        return {}
      },
      miniByBranch: state => state.Branch.miniByBranch
    }),
  },
  created() {
    this.items.forEach(item => {
      let list = [];
      if (this.form.branch && this.form.branch.mini_branch) {
        this.form.branch.mini_branch.forEach(mini => {
          if (mini.zone == item.zone_id) {
            list.push({name : mini.branch_name})
          }
        })
        item.list = list;
      }
    })

  },
  data: () => ({
    dialog: false,
    items: [
      {
        zone: "ภาคเหนือ",
        zone_id : 1,
        list: []
      },
      {
        zone: "ภาคตะวันออกเฉียงเหนือ",
        zone_id : 2,
        list: []
      },
      {
        zone: "ภาคตะวันตก",
        zone_id : 3,
        list: []
      },
      {
        zone: "ภาคกลาง",
        zone_id : 4,
        list: []
      },
      {
        zone: "ภาคตะวันออก",
        zone_id : 5,
        list: []
      },
      {
        zone: "ภาคใต้",
        zone_id : 6,
        list: []
      }
    ]
  }),
  methods: {
    onClose() {
      this.$emit("onClose");
    },
    selectItem(name) {
      this.$emit("onSelect", name);
    }
  }
};
</script>

<style lang="scss" scoped>
.branch-modal-border {
  border: 2px solid $tcdcGreen;
}
.text-branch-modal-highlight:hover {
  color: $tcdcGreen !important;
}
.dot-symbol {
  width: 10px;
  height: 10px;
  display: inline-block;
  border-radius: 100%;
}
</style>
